import React from "react";
import { useSearchParams } from "react-router-dom";
import { LogIn, Lock } from "lucide-react";
import { BUSINESS } from "../config";

export default function Login() {
  const [params] = useSearchParams();
  const error = params.get("error");

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="bg-[#050505] min-h-screen flex items-center justify-center px-5 grid-lines">
      <div className="relative w-full max-w-md border border-[var(--border-dim)] bg-[#0a0a0a] p-10" data-testid="login-card">
        <div className="flex items-center gap-3 text-[var(--accent)] mb-8"><Lock size={18} /><span className="font-mono text-xs uppercase tracking-[0.25em]">Admin Access</span></div>
        <h1 className="font-display text-4xl font-black uppercase tracking-tighter leading-none">{BUSINESS.name}</h1>
        <p className="text-[var(--text-secondary)] mt-4 mb-8">Sign in to manage leads, the CRM, and marketplace listings.</p>
        {error && <p className="text-[var(--accent)] font-mono text-xs mb-4" data-testid="login-error">Sign-in failed. Please try again.</p>}
        <button onClick={login} data-testid="google-login-btn" className="w-full btn-wipe bg-[var(--accent)] text-white hover:text-white py-4 font-mono text-sm uppercase tracking-widest font-bold flex items-center justify-center gap-2">
          <LogIn size={16} /> Continue with Google
        </button>
      </div>
    </div>
  );
}
